import { render, staticRenderFns } from "./magazzini.vue?vue&type=template&id=1eb5fcec"
import script from "./magazzini.vue?vue&type=script&lang=js"
export * from "./magazzini.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports